import React from 'react';
import { connect } from 'react-redux';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Mixpanel } from '../../redux/Mixpanel';
import {
    Row,
    Button,
    Form,
    FormGroup,
    Col,
} from 'reactstrap';
import { OCCUPANT_TYPE, colorTheme } from '../../utils/constants';

import {
    showLoading,
    fetchPropertyTenants,
    assignPayment,
    fetchCurrency,
    fetchOptions
} from '../../redux/actions';
import { check_empty_field } from './validationChecks';
import _ from 'lodash';
import CustomInput from '../../components/CustomInput';
import CustomLabel from '../../components/CustomLabel';
import { IonButton } from '@ionic/react';
import { renderTenantSearchMenu } from '../../utils/general';
import CustomPropertySelect from '../../components/CustomPropertySelect';

const mapDispatchToProps = {
    showLoading,
    fetchPropertyTenants,
    assignPayment,
    fetchCurrency,
    fetchOptions
};

const mapStateToProps = state => {
    return {
        properties: state.properties,
        units: state.units,
        tenants: state.tenants,
        payments: state.payments,
        currency: state.currency,
        options: state.options
    };
}


class AssignTenantForm extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            tenantOptions: [],
            tenant: [],
            propertyId: "",
            errors: {
                tenant: "",
            },
        }
        this.setFieldValues = this.setFieldValues.bind(this);
    }

    async componentDidMount() {
        if(_.isEmpty(this.props.currency)){
            this.props.showLoading(true);
            await this.props.fetchCurrency();
        }
        if(_.isEmpty(this.props.options)){
            this.props.showLoading(true);
            await this.props.fetchOptions();
        }
        if (Object.values(this.props.properties).length == 1){
            this.setTenantOptions(Object.values(this.props.properties)[0].propertyId);
        }
        this.setState({ propertyId: Object.values(this.props.properties).length == 1? Object.values(this.props.properties)[0].propertyId: "" })
    }

    async componentDidUpdate(prevProps, prevState){
        if (this.props.properties != prevProps.properties){
            this.setState({ properties: Object.values(this.props.properties) });
        }
    }

    async validateInput(name, value){
        let val = String(value);
        let isValid = true;
        let checks = [];

        switch(name){
            case "tenant":
                checks = [check_empty_field];
                break;
            default:
                break;
        }

        await this.setState((prevState) => {
            let errors = {...prevState.errors};
            let numErrors = prevState.numErrors;
            for (let index in checks){
                let previousError = prevState.errors[name];
                errors[name] = checks[index](val);

                if (errors[name].length > 0){
                    if (previousError.length == 0){
                        numErrors += 1
                    }
                    isValid = false;
                    break;
                }else if(previousError.length > 0){
                    numErrors -= 1
                }
            }
            return {
               errors,
               numErrors
            };
        });
        return isValid;
    }


    async setTenantOptions(propertyId=""){
        let tenantOptions = [];

        if(propertyId){
            this.props.showLoading(true)
            const action = await this.props.fetchPropertyTenants({propertyIds:[propertyId]});
            if(action && action.payload && action.payload.tenants){
                for(let tenant of Object.values(action.payload.tenants)){
                    if(!tenant.archived){
                        tenantOptions.push(this.getTenantOption(tenant));
                    }
                }
            }
        }
        let selectedTenant = this.getTenantOption(this.state.tenantDetails);

        this.setState({
            tenantOptions,
            tenant: selectedTenant? [selectedTenant] : []
        });

    }

    async onSubmit(event){
        event.preventDefault();
        let fields = ["tenant"];
        let invalid_fields = fields.filter((field)=> !(this.validateInput(field, this.state[field])));
        if (invalid_fields.length == 0) {
            this.props.showLoading(true);
            let unassignedFilter = this.props.unassignedFilter;
            const tenantDetails = this.state.tenant[0].tenantDetails;
            const action = await this.props.assignPayment(this.state.tenant[0].tenantDetails.tenantId, this.props.paymentId, unassignedFilter);
            if(!action.errors && this.props.onSuccessCallback){
                this.props.onSuccessCallback(tenantDetails.propertyId, tenantDetails);
            }
            this.setFieldValues();
        }
        Mixpanel.track("Assign payment to tenant form: assign tenant btn");
    }

    setFieldValues(propertyId="", tenant=[]){
        this.setState({
            propertyId, tenant
        })
    }

    getTenantOption(tenant){

        if (tenant){
            let tenantAccountId = tenant.accountId? tenant.accountId :"_";
            let label = "";
            if(tenant?.archived){
                label += "[Archived] - "
            }
            label += tenantAccountId + " - " + tenant.firstName + " " + tenant.lastName;
            if(tenant.propertyId in this.props.properties){
                label += " (" + this.props.properties[tenant.propertyId].propertyName

                if(tenant.unitId in this.props.units){
                    label += " : " + this.props.units[tenant.unitId].unitName
                }

                label += ")"
            }

            return {
                id: tenant.tenantId,
                tenantDetails: tenant,
                label: label
            };
        }{
            return null;
        }
    }

    async handleSelectProperty(event){
        event.preventDefault();
        let value = event.target.value;
        this.setState((prevState) => {
            let { propertyId } = prevState;
            if (propertyId != value){
                this.setTenantOptions(value);
                propertyId = value;
            }
            return {
                propertyId
            };
        });
    }

    async handleChangedOptions(name, selected){
        this.setState({[name]: selected});
        this.validateInput(name, selected);
    }

    render(){
        let currency = this.props.currency.customerCurrency || "";
        let amount = this.props.payments[this.props.paymentId]?.amount || this.props.amount || 0;
        let paymentId = this.props.paymentId || "";
        let payments = this.props.payments[paymentId] || {};
        return (
        <Row>
            <Row className='mb-4'>

            {this.props.paymentId && this.props.payments[this.props.paymentId] && (
                    <Col lg={12} className="pt-2 pb-1" data-testid="assignTenantFormTitle">
                        <Row className='my-1'>
                            <CustomLabel xs={4} sm={3}>
                                Payment ID
                            </CustomLabel>
                            <Col xs={8} sm={8}>
                                {this.props.paymentId}
                            </Col>
                        </Row>

                        <Row className='my-1'>
                            <CustomLabel xs={4} sm={3}>
                                Amount
                            </CustomLabel>
                            <Col xs={8} sm={8} >
                                {`${this.props.currency.customerCurrency} ${this.props.payments[this.props.paymentId].amount}`}
                            </Col>
                        </Row>

                        <Row className='my-1'>
                            <CustomLabel xs={12} sm={3}>
                                Description
                            </CustomLabel>
                            <Col xs={12} sm={8}>
                                {this.props.payments[this.props.paymentId].description || "No description available"}
                            </Col>
                        </Row>
                    </Col>
                    )}

                </Row>

                <FormGroup row>
                    <CustomLabel for="propertyId" sm={12} md={3}>
                        Select {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}
                    </CustomLabel>

                    <Row>
                        <Col style={{maxWidth: '450px'}} xs={12} sm={12}>
                            <CustomInput
                                type="select"
                                id="propertyId"
                                name="propertyId"
                                className="mr-2"
                                onChange={this.handleSelectProperty.bind(this)}
                                value={this.state.propertyId}
                            >
                                <CustomPropertySelect propertiesArray={this.props.properties}/>
                            </CustomInput>
                        </Col>

                        <Col id='assignTenantContainer' style={{maxWidth: '450px'}} xs={12} sm={12}>
                            <Typeahead
                                emptyLabel={this.state.propertyId==="" ? `Please first select ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} property.` : `Choose ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"}. No matches found.`}
                                placeholder={`Select ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant(s)" : "member(s)"} ...`}
                                id='tenant'
                                clearButton
                                options={this.state.tenantOptions}
                                name="tenant"
                                selected={this.state.tenant}
                                paginate={false}
                                maxResults={10000000}  // chose a high number because we don't want to handle pagination. Just show all results.
                                onChange={this.handleChangedOptions.bind(this, "tenant")}
                                renderMenu={renderTenantSearchMenu}
                            >
                            </Typeahead>
                            {this.state.errors.tenant.length > 0 && <p className="text-danger">{this.state.errors.tenant}</p>}
                        </Col>
                    </Row>

                </FormGroup>

            <Row>
                <Col sm={12}>
                    <Form onSubmit={this.onSubmit.bind(this)}>
                    <IonButton
                        style={{
                            backgroundColor: colorTheme["primary"]["700"] }}
                        size='md'
                        id="assignTenantFormBtn"
                        type="submit"
                        disabled={this.state.tenant.length==0}
                        >
                        Assign {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}
                    </IonButton>
                    </Form>

                </Col>
            </Row>
            </Row>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AssignTenantForm);